import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';

import { 
  Typography, 
  TextField, 
  MenuItem,
  Button,
  FormControlLabel,
  Radio 
} from '@material-ui/core';


import DateFnsUtils from '@date-io/date-fns';
import krLocale from "date-fns/locale/ko";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';

import Autocomplete from '@material-ui/lab/Autocomplete';

import { IsNoU } from 'common/utils';

import { templateTypes, adTypes, onoffTaxis } from "common/datas";

const useStyles = makeStyles(theme => ({
  root: {},
  row: {
    height: '62px',
    display: 'flex',
    alignItems: 'center',
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  rowIcons: {
    height: '62px',
    display: 'flex',
    alignItems: 'center',
    //paddingLeft: theme.spacing(8),
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  searchInput: {
    marginRight: theme.spacing(1)
  },
  registerListItemTitle: {
    marginLeft: theme.spacing(2),
    width: '100px',
  },
  registerListItemInput: {
    //marginLeft: theme.spacing(2),
    width: '240px',
    //height: '40px',
  },
  find_advertise_name_input: {
    //marginLeft: theme.spacing(2),
    width: '480px',
    //height: '40px',
  },
}));

const StatisticsToolbar = props => {
  //const { className, ...rest } = props;

  const { 
    className, 
    userRole,
    type,
    find_type,
    set_find_type,
    onClickFindLogs,
    onClickDeleteLogs,
    advertises,

    selectedDeleteStartDate,
    setSelectedDeleteStartDate,
    selectedDeleteEndDate,
    setSelectedDeleteEndDate,

    company_names,
    car_numbers,
    // agencies,
    // clients,
    agencies,
    clients,
    selectedAgency, 
    onChangeAgency,
    selectedClient,
    //onSetSelectedClient,
    onChangeClient,
    areas,
    groups,
//    cars,
    ...rest
 } = props;

  const classes = useStyles();

  const [checkedType, setCheckedType] = useState(find_type);
  const handleChangeSwitchRadio = name => event => {
    //console.log('handleChangeSwitchRadio => '+event.target.checked);
    if (name==='checkedDay') {
      //setState({ ...state, ['checkedImage']: !event.target.checked });
      setCheckedType(1);
      set_find_type(1);
    }
    else if (name==='checkedDetail') {
      setCheckedType(2);
      set_find_type(2);
    }
    else {
      setCheckedType(0);
      set_find_type(0);
    }
  };

  const [selectedStartDate, setSelectedStartDate] = useState(new Date());
  const [selectedEndDate, setSelectedEndDate] = useState(new Date());
  const [advertiseName, setAdvertiseName] = useState('');


  // const [selectedAgency, setSelectedAgency] = useState('');
  // const [selectedClient, setSelectedClient] = useState('');

  const [selectedArea, setSelectedArea] = useState('');
  const [selectedGroup, setSelectedGroup] = useState('');

  const [selectedTemplate, setSelectedTemplate] = useState('');
  const [selectedAdType, setSelectedAdType] = useState('');

  const [selectedCompany, setSelectedCompany] = useState('');
  const [selectedCarNumber, setSelectedCarNumber] = useState('');

  const [selectedOnTaxi, setSelectedOnTaxi] = useState('');

  const [areaGroups, setAreaGroups] = useState([]);

  const handleChangeArea = (e) => {
    let newAreaGroups = groups.filter(group => group.area === e.target.value);
    //console.log('new groups ->');
    //console.log(newAreaGroups);
    setAreaGroups(newAreaGroups);
    setSelectedGroup('');
    setSelectedArea(e.target.value)
  }

  useEffect(() => {
    //console.log('componentDidUpdate & type changed');

    if (type === 'advertise') {
      setCheckedType(0);
      set_find_type(0);
    }
    else {
      setCheckedType(1);
      set_find_type(1);
    }
 
  }, [type]);

  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      {type === 'advertise' && (
        <div className={classes.row}>
          <FormControlLabel
            control={
              <Radio
                checked={checkedType === 0}
                onChange={handleChangeSwitchRadio('checkedAll')}
                value="checkedType"
                color="primary"
              />
            }
            label="전체검색"
          />

          <FormControlLabel
            control={
              <Radio
                checked={checkedType === 1}
                onChange={handleChangeSwitchRadio('checkedDay')}
                value="checkedType"
                color="primary"
              />
            }
            label="일별검색"
          />

          <FormControlLabel
            control={
              <Radio
                checked={checkedType === 2}
                onChange={handleChangeSwitchRadio('checkedDetail')}
                value="checkedType"
                color="primary"
              />
            }
            label="상세검색"
          />

          <Button
            color="primary"
            variant="contained"
            onClick={ () => onClickFindLogs(checkedType, 
              selectedStartDate, 
              selectedEndDate,
              advertiseName,
              selectedAgency,
              selectedClient,
              selectedArea,
              selectedGroup,
              selectedTemplate,
              selectedAdType,
              selectedCompany,
              selectedCarNumber,
              undefined
              ) }
          >
            조회
          </Button>
        </div>
      )}
      {type === 'taxi' && (
        <div className={classes.row}>
          <FormControlLabel
            control={
              <Radio
                checked={checkedType === 1}
                onChange={handleChangeSwitchRadio('checkedDay')}
                value="checkedType"
                color="primary"
              />
            }
            label="일별검색"
          />

          <FormControlLabel
            control={
              <Radio
                checked={checkedType === 2}
                onChange={handleChangeSwitchRadio('checkedDetail')}
                value="checkedType"
                color="primary"
              />
            }
            label="상세검색"
          />

          <Button
            color="primary"
            variant="contained"
            onClick={ e => onClickFindLogs(checkedType, 
              selectedStartDate, 
              selectedEndDate,
              undefined, //advertiseName,
              undefined, //selectedAgency,
              undefined, //selectedClient,
              undefined, //selectedArea,
              undefined, //selectedGroup,
              undefined, //selectedTemplate,
              undefined, //selectedAdType,
              selectedCompany,
              selectedCarNumber,
              selectedOnTaxi) }
          >
            조회
          </Button>
        </div>
        )}
        {type === 'client' && (
          <div>
            <div className={classes.row}>

              <Typography
                className={classes.registerListItemTitle}
                color="textSecondary"
                gutterBottom
              >
                조회일자
              </Typography>

              <MuiPickersUtilsProvider utils={DateFnsUtils} locale={krLocale}>

                <KeyboardDatePicker
                  disableToolbar
                  variant="inline"
                  format="yyyy-MM-dd"
                  margin="dense"
                  id="date-picker-inline1"
                  value={selectedStartDate}
                  onChange={date => setSelectedStartDate(date)}
                  KeyboardButtonProps={{
                    'aria-label': 'change date',
                  }}
                />

                <Typography
                  className={classes.registerListItemDateGap}
                  color="textSecondary"
                  gutterBottom
                >
                  ~
                </Typography>

                <KeyboardDatePicker
                  disableToolbar
                  variant="inline"
                  format="yyyy-MM-dd"
                  margin="dense"
                  id="date-picker-inline2"
                  value={selectedEndDate}
                  onChange={date => setSelectedEndDate(date)}
                  KeyboardButtonProps={{
                    'aria-label': 'change date',
                  }}
                />

                </MuiPickersUtilsProvider>

                <Button
                  color="primary"
                  variant="contained"
                  onClick={ e => onClickFindLogs(-1, 
                    selectedStartDate, 
                    selectedEndDate,
                    undefined, //advertiseName,
                    selectedAgency,
                    selectedClient,
                    undefined, //selectedArea,
                    undefined, //selectedGroup,
                    undefined, //selectedTemplate,
                    undefined, //selectedAdType,
                    undefined, //selectedCompany,
                    undefined, //selectedCarNumber,
                    undefined, //selectedOnTaxi
                    ) 
                  }
                >
                  조회
                </Button>
              </div>
          </div>
        )}


        {(type === 'advertise' || type === 'taxi') && (
          <>
            <div className={classes.row}>
              <Typography
                className={classes.registerListItemTitle}
                color="textSecondary"
                gutterBottom
              >
                조회일자
              </Typography>

              <MuiPickersUtilsProvider utils={DateFnsUtils} locale={krLocale}>

                <KeyboardDatePicker
                  disableToolbar
                  variant="inline"
                  format="yyyy-MM-dd"
                  margin="dense"
                  id="date-picker-inline3"
                  value={selectedStartDate}
                  onChange={date => setSelectedStartDate(date)}
                  KeyboardButtonProps={{
                    'aria-label': 'change date',
                  }}
                  //disabled={checkedType!==1}
                />

                <Typography
                  className={classes.registerListItemDateGap}
                  color="textSecondary"
                  gutterBottom
                >
                  ~
                </Typography>

                <KeyboardDatePicker
                  disableToolbar
                  variant="inline"
                  format="yyyy-MM-dd"
                  margin="dense"
                  id="date-picker-inline4"
                  value={selectedEndDate}
                  onChange={date => setSelectedEndDate(date)}
                  KeyboardButtonProps={{
                    'aria-label': 'change date',
                  }}
                  //disabled={checkedType!==1}
                />

              </MuiPickersUtilsProvider>
            </div>
            { type === 'advertise' && (
              <div className={classes.row}>
                <Typography
                  className={classes.registerListItemTitle}
                  color="textSecondary"
                  gutterBottom
                >
                  광고명
                </Typography>
                <TextField
                  className={classes.find_advertise_name_input}
                  id="outlined-basic1" 
                  //variant="outlined"
                  value={advertiseName}
                  onChange={(e) => setAdvertiseName(e.target.value)}
                  margin="dense" 
                  //disabled={checkedType!==2}
                  />
              </div>
            )}
          </>
        )}

        {type === 'advertise' && (
          <div>
            <div className={classes.row}>

              <Typography
                className={classes.registerListItemTitle}
                color="textSecondary"
                gutterBottom
              >
                광고대행사
              </Typography>
              <TextField
                className={classes.registerListItemInput}
                id="outlined-select-currency"
                select
                //disabled={checkedType!==2}
                value={selectedAgency}
                //onChange={e => setSelectedAgency(e.target.value)}
                onChange={e => onChangeAgency(e)}
                //variant="outlined"
                margin="dense"
              >
                {agencies.map(agency => (
                  <MenuItem key={agency.name} value={agency.name}>
                    {agency.name}
                  </MenuItem>
                ))}
              </TextField>

              <Typography
                className={classes.registerListItemTitle}
                color="textSecondary"
                gutterBottom
              >
                광고주
              </Typography>
              <TextField
                className={classes.registerListItemInput}
                id="outlined-select-currency"
                select
                //disabled={checkedType!==2}
                value={selectedClient}
                //onChange={e => setSelectedClient(e.target.value)}
                onChange={e => onChangeClient(e)}
                //variant="outlined"
                margin="dense"
                helperText="* 광고대행사선택후 선택하세요"
              >
                {clients.map(client => (
                  <MenuItem key={client.name} value={client.name}>
                    {client.name}
                  </MenuItem>
                ))}
              </TextField>

            </div>

            <div className={classes.row}>

              <Typography
                className={classes.registerListItemTitle}
                color="textSecondary"
                gutterBottom
              >
                권역
              </Typography>

              <TextField
                className={classes.registerListItemInput}
                id="outlined-select-agency"
                select
                //disabled={checkedType!==2}
                value={selectedArea}
                onChange={handleChangeArea}
                helperText=""
                //variant="outlined"
                margin="dense"
              >
                {areas.map(option => (
                  <MenuItem key={option.name} value={option.name}>
                    {option.name}
                  </MenuItem>
                ))}
              </TextField>

              <Typography
                className={classes.registerListItemTitle}
                color="textSecondary"
                gutterBottom
              >
                그룹
              </Typography>
              <TextField
                className={classes.registerListItemInput}
                id="outlined-select-client"
                select
                //disabled={checkedType!==2}
                value={selectedGroup}
                onChange={e => setSelectedGroup(e.target.value)}
                helperText=""
                //variant="outlined"
                margin="dense"
                helperText="* 권역선택후 선택하세요"
              >
                {areaGroups.map(option => (
                  <MenuItem key={option.name} value={option.name}>
                    {option.name}
                  </MenuItem>
                ))}
              </TextField>
            </div>

            <div className={classes.row}>
              <Typography
                className={classes.registerListItemTitle}
                color="textSecondary"
                gutterBottom
              >
                택시회사명
              </Typography>
              <Autocomplete
                id="statistic-toolbar-taxi-find-company-name-auto"
                options={company_names.map(company => company.name)}
                // getOptionLabel={
                //   option => option.name
                //   //option => option
                // }
                //disabled={checkedType!==2}
                style={{ width: 240 }}
                value={selectedCompany}
                onChange={(event, newValue) => {
                  //console.log(newValue);
                  // if (!IsNoU(newValue) && newValue.length > 0) {
                  //   const selectedCar = cars.find(car => (car.number === newValue));
                  //   if (!IsNoU(selectedCar)) {
                  //     setSelectedCompany(selectedCar.company);
                  //   }
                  //   else {
                  //     setSelectedCompany('');
                  //   }
                  // }
                  // else {
                  //   setSelectedCompany('');
                  // }
                  
                  setSelectedCompany(newValue);
                }}
                // onChange={event=> setSelectedCompany(event.target.value)}
                renderInput={params => (
                  <TextField {...params} 
                    //variant="outlined" 
                    fullWidth 
                    margin="dense" />
                )}
              />

              <Typography
                className={classes.registerListItemTitle}
                color="textSecondary"
                gutterBottom
              >
                차량번호
              </Typography>
              <Autocomplete
                id="statistic-toolbar-taxi-find-car-name-auto"
                options={car_numbers.map(car => car.number)}
                // getOptionLabel={
                //   option => option.name
                //   //option => option
                // }
                //disabled={checkedType!==2}
                style={{ width: 240 }}
                value={selectedCarNumber}
                onChange={(event, newValue) => {
                  //console.log(newValue);
                  // if (!IsNoU(newValue) && newValue.length > 0) {
                  //   const selectedCar = cars.find(car => (car.number === newValue));
                  //   if (!IsNoU(selectedCar)) {
                  //     setSelectedCompany(selectedCar.company);
                  //   }
                  //   else {
                  //     setSelectedCompany('');
                  //   }
                  // }
                  // else {
                  //   setSelectedCompany('');
                  // }
                  
                  setSelectedCarNumber(newValue);
                }}
                // onChange={event=> setSelectedCompany(event.target.value)}
                renderInput={params => (
                  <TextField {...params} 
                    //variant="outlined" 
                    fullWidth 
                    margin="dense" />
                )}
              />
            </div>

            <div className={classes.row}>
              <Typography
                className={classes.registerListItemTitle}
                color="textSecondary"
                gutterBottom
              >
                탬플릿
              </Typography>

              <TextField
                className={classes.registerListItemInput}
                id="outlined-select-agency"
                select
                //disabled={checkedType!==2}
                value={selectedTemplate}
                onChange={e => setSelectedTemplate(e.target.value)}
                helperText=""
                //variant="outlined"
                margin="dense"
              >
                {[{value:'전체', label: '전체'}, ...templateTypes].map(option => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>

              <Typography
                className={classes.registerListItemTitle}
                color="textSecondary"
                gutterBottom
              >
                광고유형
              </Typography>
              <TextField
                className={classes.registerListItemInput}
                id="outlined-select-client"
                select
                //disabled={checkedType!==2}
                value={selectedAdType}
                onChange={e => setSelectedAdType(e.target.value)}
                helperText=""
                //variant="outlined"
                margin="dense"
              >
                {adTypes.map(option => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
            </div>

            {userRole !== 'user' && (
              <div className={classes.row}>

                <Typography
                  className={classes.registerListItemTitle}
                  color="textSecondary"
                  gutterBottom
                >
                  일괄삭제
                </Typography>

                <MuiPickersUtilsProvider utils={DateFnsUtils} locale={krLocale}>

                  <KeyboardDatePicker
                    disableToolbar
                    variant="inline"
                    format="yyyy-MM-dd"
                    margin="dense"
                    id="date-picker-inline5"
                    value={selectedDeleteStartDate}
                    onChange={date => setSelectedDeleteStartDate(date)}
                    KeyboardButtonProps={{
                      'aria-label': 'change date',
                    }}
                  />

                  <Typography
                    className={classes.registerListItemDateGap}
                    color="textSecondary"
                    gutterBottom
                  >
                    ~
                  </Typography>

                  <KeyboardDatePicker
                    disableToolbar
                    variant="inline"
                    format="yyyy-MM-dd"
                    margin="dense"
                    id="date-picker-inline6"
                    value={selectedDeleteEndDate}
                    onChange={date => setSelectedDeleteEndDate(date)}
                    KeyboardButtonProps={{
                      'aria-label': 'change date',
                    }}
                  />

                </MuiPickersUtilsProvider>

                <Button
                  style={{
                  //  borderRadius: 35,
                    backgroundColor: "#E00000",
                    color: "#FFFFFF"
                    // padding: "18px 36px",
                    // fontSize: "18px"
                  }}
                  variant="contained" 
                  //color="inherit"
                  onClick={ e => onClickDeleteLogs(selectedStartDate, selectedEndDate) }
                >
                  삭제
                </Button>
              </div>
            )}
          </div>
        )}

        {type === 'taxi' && (
        <div>
          <div className={classes.row}>
            <Typography
              className={classes.registerListItemTitle}
              color="textSecondary"
              gutterBottom
            >
              택시회사명
            </Typography>
            <Autocomplete
              id="statistic-toolbar-taxi-find-company-name-auto"
              options={company_names.map(company => company.name)}
              // getOptionLabel={
              //   option => option.name
              //   //option => option
              // }
              style={{ width: 260 }}
              value={selectedCompany}
              onChange={(event, newValue) => {
                //console.log(newValue);
                // if (!IsNoU(newValue) && newValue.length > 0) {
                //   const selectedCar = cars.find(car => (car.number === newValue));
                //   if (!IsNoU(selectedCar)) {
                //     setSelectedCompany(selectedCar.company);
                //   }
                //   else {
                //     setSelectedCompany('');
                //   }
                // }
                // else {
                //   setSelectedCompany('');
                // }
                
                setSelectedCompany(newValue);
              }}
              // onChange={event=> setSelectedCompany(event.target.value)}
              renderInput={params => (
                <TextField {...params} 
                  //variant="outlined" 
                  fullWidth 
                  margin="dense" />
              )}
            />

            <Typography
              className={classes.registerListItemTitle}
              color="textSecondary"
              gutterBottom
            >
              차량번호
            </Typography>
            <Autocomplete
              id="statistic-toolbar-taxi-find-car-name-auto"
              options={car_numbers.map(car => car.number)}
              // getOptionLabel={
              //   option => option.name
              //   //option => option
              // }
              style={{ width: 260 }}
              value={selectedCarNumber}
              onChange={(event, newValue) => {
                //console.log(newValue);
                // if (!IsNoU(newValue) && newValue.length > 0) {
                //   const selectedCar = cars.find(car => (car.number === newValue));
                //   if (!IsNoU(selectedCar)) {
                //     setSelectedCompany(selectedCar.company);
                //   }
                //   else {
                //     setSelectedCompany('');
                //   }
                // }
                // else {
                //   setSelectedCompany('');
                // }
                
                setSelectedCarNumber(newValue);
              }}
              // onChange={event=> setSelectedCompany(event.target.value)}
              renderInput={params => (
                <TextField {...params} 
                  //variant="outlined" 
                  fullWidth 
                  margin="dense" />
              )}
            />
          </div>

          {type === 'taxi' && (
            <div className={classes.row}>
              <Typography
                className={classes.registerListItemTitle}
                color="textSecondary"
                gutterBottom
              >
                승/하차
              </Typography>

              <TextField
                className={classes.registerListItemInput}
                id="outlined-select-agency"
                select
                value={selectedOnTaxi}
                onChange={e => setSelectedOnTaxi(e.target.value)}
                helperText=""
                //variant="outlined"
                margin="dense"
              >
                {onoffTaxis.map(option => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>

            </div>
          )}

          {userRole !== 'user' && (
            <div className={classes.row}>

              <Typography
                className={classes.registerListItemTitle}
                color="textSecondary"
                gutterBottom
              >
                일괄삭제
              </Typography>

              <MuiPickersUtilsProvider utils={DateFnsUtils} locale={krLocale}>

                <KeyboardDatePicker
                  disableToolbar
                  variant="inline"
                  format="yyyy-MM-dd"
                  margin="dense"
                  id="date-picker-inline7"
                  value={selectedDeleteStartDate}
                  onChange={date => setSelectedDeleteStartDate(date)}
                  KeyboardButtonProps={{
                    'aria-label': 'change date',
                  }}
                />

                <Typography
                  className={classes.registerListItemDateGap}
                  color="textSecondary"
                  gutterBottom
                >
                  ~
                </Typography>

                <KeyboardDatePicker
                  disableToolbar
                  variant="inline"
                  format="yyyy-MM-dd"
                  margin="dense"
                  id="date-picker-inline8"
                  value={selectedDeleteEndDate}
                  onChange={date => setSelectedDeleteEndDate(date)}
                  KeyboardButtonProps={{
                    'aria-label': 'change date',
                  }}
                />

              </MuiPickersUtilsProvider>

              <Button
                style={{
                //  borderRadius: 35,
                  backgroundColor: "#E00000",
                  color: "#FFFFFF"
                  // padding: "18px 36px",
                  // fontSize: "18px"
                }}
                variant="contained" 
                //color="inherit"
                onClick={ e => onClickDeleteLogs(selectedStartDate, selectedEndDate) }
              >
                삭제
              </Button>
            </div>
          )}
        </div>
      )}

      {type === 'client' && (
        <div>
          <div className={classes.row}>
            <Typography
              className={classes.registerListItemTitle}
              color="textSecondary"
              gutterBottom
            >
              광고대행사
            </Typography>
            <TextField 
              className={classes.registerListItemInput}
              id="outlined-select-currency"
              select
              value={selectedAgency}
              //onChange={e => setSelectedAgency(e.target.value)}
              onChange={e => onChangeAgency(e)}
              //variant="outlined"
              margin="dense"
            >
              {agencies.map(agency => (
                <MenuItem key={agency.name} value={agency.name}>
                  {agency.name}
                </MenuItem>
              ))}
            </TextField>

            <Typography
              className={classes.registerListItemTitle}
              color="textSecondary"
              gutterBottom
            >
              광고주
            </Typography>
            <TextField
              className={classes.registerListItemInput}
              id="outlined-select-currency"
              select
              value={selectedClient}
              //onChange={e => setSelectedClient(e.target.value)}
              onChange={e => onChangeClient(e)}
              //variant="outlined"
              margin="dense"
              helperText="* 광고대행사선택후 선택하세요"
            >
              {clients.map(client => (
                <MenuItem key={client.name} value={client.name}>
                  {client.name}
                </MenuItem>
              ))}
            </TextField>
          </div>
        </div>
      )}

    </div>
  );
};

StatisticsToolbar.propTypes = {
  className: PropTypes.string,
  type: PropTypes.string,
  companies: PropTypes.array.isRequired,
  agencies: PropTypes.array.isRequired,
  clients: PropTypes.array.isRequired,
  areas: PropTypes.array.isRequired,
  groups: PropTypes.array.isRequired,
//  cars: PropTypes.array.isRequired,
};

StatisticsToolbar.defaultProps = {
  companies: [],
  agencies: [],
  clients: [],
  areas: [],
  groups: [],
//  cars: [],
};

export default StatisticsToolbar;
